import React from 'react';
import { IEquityHistory } from './IEquityHistory';
import { connect } from 'react-redux';
import { TReducers } from '@features/reducers';
import EquityHistoryTable from '../EquityHistoryTable/EquityHistoryTable';
import WhitePaper from '@appComponents/WhitePaper/WhitePaper';
import * as style from './EquityHistoryStyle.module.scss'

export const EquityHistory = (props: IEquityHistory) => {

  return (
    <WhitePaper headline="Equities" className={style.adjustedPaper}>
      <EquityHistoryTable equityCompanies={[...props.equityCompanies]} />
    </WhitePaper>
  );
};

const mapStateToProps = (store: TReducers) => ({
  equityCompanies: store.portfolioReducer.companies
    .filter(company => company.equity && company.equity.value && company.details),
});

export default connect(mapStateToProps)(EquityHistory);
